/* migrated from app/script/component/cookie.js */
(() => {
  // app/script/component/cookie.js
  document.addEventListener("DOMContentLoaded", function() {
    console.log("cookie.js loaded");
    setTimeout(function() {
      const cookie = document.querySelector('section[id="shopify-pc__banner"]');
      console.log("cookie::", cookie);
      if (cookie) {
        cookie.addEventListener("click", (e) => {
          const isCookieClicked = e.target.closest(".shopify-pc__banner__btn-accept") || e.target.closest(".shopify-pc__banner__btn-decline");
          setTimeout(() => {
            if (isCookieClicked) {
              if (!window.customer) {
                console.log("window.customer is null");
                const subscribeScrollHandler = function() {
                  console.log("window.scrollY::", window.scrollY);
                  console.log("window.innerHeight::", window.innerHeight);
                  if (window.scrollY > 1e3) {
                    console.log("window.scrollY is larger than 2 * window.innerHeight");
                    document.dispatchEvent(new CustomEvent("subscribe-popup:open", { bubbles: true, composed: true }));
                    window.removeEventListener("scroll", subscribeScrollHandler);
                  }
                };
                window.addEventListener("scroll", subscribeScrollHandler);
              } else {
                console.log("window.customer is not null");
                const welcomeScrollHandler = function() {
                  if (window.scrollY > 500) {
                    console.log("window.scrollY is larger than 500");
                    document.dispatchEvent(new CustomEvent("welcome-popup:open", { bubbles: true, composed: true }));
                    window.removeEventListener("scroll", welcomeScrollHandler);
                  }
                };
                window.addEventListener("scroll", welcomeScrollHandler);
              }
            }
          }, 600);
        });
      }
    }, 1e3);
  });
})();
